import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['label']
    static outlets = ['toggle-receiver']
    static values = {
        activeLabel: String,
        inactiveLabel: String,
        activeTitle: String,
        inactiveTitle: String,
        preventLenis: Boolean
    }

    toggleReceiverOutletConnected(receiver) {
        const controls = (this.element.getAttribute('aria-controls') ?? '').split(' ').filter(Boolean);

        if (!receiver.element.id) {
            receiver.element.setAttribute('id', (Math.random() + 1).toString(36).substring(7));
        }

        if (!controls.includes(receiver.element.id)) {
            controls.push(receiver.element.id);
        }

        this.element.setAttribute('aria-controls', controls.join(' '));
        this.element.setAttribute('aria-expanded', receiver.isOpen());
    }

    toggle(event) {
        for (const receiver of this.toggleReceiverOutlets) {
            receiver.toggle(event);
        }
    }

    open(event) {
        for (const receiver of this.toggleReceiverOutlets) {
            receiver.open(event);
        }
    }

    close(event) {
        for (const receiver of this.toggleReceiverOutlets) {
            receiver.close(event);
        }
    }

    /**
     * Updates the attributes and label of the handler according to the given state, whenever applicable.
     * Executed by the receiver outlet whenever its state changes by handlers or its own actions.
     */
    setState(state) {
        this.element.setAttribute('aria-expanded', state);

        if (this.hasActiveClass) {
            this.element.classList.toggle('active', state);
        }

        if (state) {
            if (this.activeTitleValue) {
                this.element.title = this.activeTitleValue;
            }

            if (this.activeLabelValue) {
                if (this.element.hasAttribute('aria-label')) {
                    this.element.setAttribute('aria-label', this.activeLabelValue);
                } else if (this.hasLabelTarget) {
                    this.labelTarget.textContent = this.activeLabelValue;
                } else {
                    this.element.textContent = this.activeLabelValue;
                }
            }
        } else {
            if (this.inactiveTitleValue) {
                this.element.title = this.inactiveTitleValue;
            }

            if (this.inactiveLabelValue) {
                if (this.element.hasAttribute('aria-label')) {
                    this.element.setAttribute('aria-label', this.inactiveLabelValue);
                } else if (this.hasLabelTarget) {
                    this.labelTarget.textContent = this.inactiveLabelValue;
                } else {
                    this.element.textContent = this.inactiveLabelValue;
                }
            }
        }

        if (this.preventLenisValue) {
            if (state) {
                document.body.setAttribute('data-lenis-prevent', '');
            } else {
                document.body.removeAttribute('data-lenis-prevent');
            }
        }
    }
}
